import { WorkflowController } from './workflow.controller'
import { KanbanController } from './pages/kanban/kanban.controller'
import { TaskListController } from './pages/task-list/task-list.controller'
import { WorkflowCalendarController } from './pages/calendar/workflow-calendar.controller'
import { MarketingCalendarController } from './pages/marketing-calendar/marketing-calendar.controller'
import { HomeController } from './pages/home/home.controller'
import { BriefingsPageController } from './pages/briefings/briefings-page.controller'
import { RequestsController } from './pages/requests/requests.controller'

const checkModuleEnabled = [
  '$rootScope',
  '$q',
  '$state',
  ($rootScope, $q, $state) => {
    const deferred = $q.defer()

    $rootScope.getCompanyFeaturesAndAddons()
      .then(({ features }) => {
        if (features['WORKFLOW.ACCESS']) {
          deferred.resolve()
        } else {
          deferred.reject()
        }
      })

    return deferred.promise
      .catch(() => {
        $state.go('home')
      })
  }
]

const checkIsUserSysAdminAdmin = [
  '$rootScope',
  '$q',
  '$state',
  ($rootScope, $q, $state) => {
    const deferred = $q.defer()
    $rootScope.getUser()
      .then((loggedUser) => {
        if ($rootScope.isUserSysAdminAdmin(loggedUser)) {
          deferred.resolve()
        } else {
          deferred.reject()
        }
      })

    return deferred.promise
      .catch(() => {
        $state.go('workflow')
      })
  }
]

const checkCanAccessKanban = [
  '$rootScope',
  '$q',
  '$state',
  '$stateParams',
  ($rootScope, $q, $state, $stateParams) => {
    const deferred = $q.defer()
    $rootScope.getUser()
      .then((loggedUser) => {
        if ($rootScope.isUserSysAdminAdminDesigner(loggedUser)) {
          deferred.resolve()
        } else {
          deferred.reject()
        }
      })

    return deferred.promise
      .catch(() => {
        $state.go('workflow.requests', { request: $stateParams.request })
      })
  }
]

const checkUserEnabledCalendar = [
  '$rootScope',
  '$q',
  '$state',
  ($rootScope, $q, $state) => {
    const deferred = $q.defer()

    $rootScope.getCompanyFeaturesAndAddons().then(({ features }) => {
      if (!features['CAMPAIGNS.ACCESS'] && !features['WORKFLOW.ACCESS']) {
        return deferred.reject()
      }

      $rootScope.getUser().then(loggedUser => {
        if ($rootScope.isUserSysAdminAdminDesigner(loggedUser)) {
          return deferred.resolve()
        } else {
          return deferred.reject()
        }
      })
    })

    return deferred.promise
      .catch(() => {
        $state.go('workflow')
      })
  }
]

/* @ngInject */
function routes ($stateProvider, $urlRouterProvider) {
  $urlRouterProvider
    .when('/workflow/?task', '/workflow?task') // TODO: move to kanban

  $stateProvider
    .state('workflow', {
      url: '/workflow',
      reloadOnSearch: false,
      resolve: {
        checkModuleEnabled
      },
      views: {
        '': {
          templateUrl: '/workflow/workflow.html?$$REVISION$$',
          controller: WorkflowController
        }
      }
    })
    .state('workflow.home', {
      parent: 'workflow',
      url: '/home?createRequest&request',
      reloadOnSearch: false,
      resolve: {
        checkModuleEnabled
      },
      views: {
        'home@workflow': {
          templateUrl: '/workflow/pages/home/home.html?$$REVISION$$',
          controller: HomeController
        }
      },
      params: {
        createRequest: '',
        request: '',
        tab: '',
        filter: ''
      }
    })
    .state('workflow.kanban', {
      parent: 'workflow',
      url: '/kanban?board&request',
      reloadOnSearch: false,
      resolve: {
        checkModuleEnabled,
        checkCanAccessKanban
      },
      views: {
        'kanban@workflow': {
          templateUrl: '/workflow/pages/kanban/kanban.html?$$REVISION$$',
          controller: KanbanController
        }
      },
      params: {
        param: '',
        board: '',
        request: '',
        task: ''
      }
    })
    .state('workflow.requests', {
      parent: 'workflow',
      url: '/requests?request',
      reloadOnSearch: false,
      resolve: {
        checkModuleEnabled
      },
      views: {
        'requests@workflow': {
          templateUrl: '/workflow/pages/requests/requests.html?$$REVISION$$',
          controller: RequestsController
        }
      },
      params: {
        createRequest: '',
        request: '',
        from: ''
      }
    })
    .state('workflow.list', {
      parent: 'workflow',
      url: '/list?board',
      reloadOnSearch: false,
      resolve: {
        checkModuleEnabled
      },
      views: {
        'list@workflow': {
          templateUrl: '/workflow/pages/task-list/task-list.html?$$REVISION$$',
          controller: TaskListController
        }
      },
      params: {
        param: '',
        board: '',
        request: '',
        task: ''
      }
    })
    .state('workflow.calendar', {
      parent: 'workflow',
      url: '/calendar?board',
      reloadOnSearch: false,
      resolve: {
        checkModuleEnabled
      },
      views: {
        'calendar@workflow': {
          templateUrl: '/workflow/pages/calendar/workflow-calendar.html?$$REVISION$$',
          controller: WorkflowCalendarController
        }
      },
      params: {
        param: '',
        board: '',
        request: '',
        task: ''
      }
    })
    .state('workflow.briefings', {
      parent: 'workflow',
      url: '/briefings',
      reloadOnSearch: false,
      resolve: {
        checkModuleEnabled,
        checkIsUserSysAdminAdmin
      },
      views: {
        'briefings@workflow': {
          templateUrl: '/workflow/pages/briefings/briefings-page.html?$$REVISION$$',
          controller: BriefingsPageController
        }
      }
    })
    .state('request', {
      url: '/request/:id',
      reloadOnSearch: false,
      resolve: {
        checkModuleEnabled
      },
      views: {
        '': {
          templateUrl: '/workflow/pages/request/request.html?$$REVISION$$',
          controller: RequestsController
        }
      }
    })
    .state('marketingCalendar', {
      url: '/calendar',
      reloadOnSearch: false,
      params: {
        originModule: null,
        selectedBoard: null
      },
      resolve: {
        checkUserEnabledCalendar
      },
      views: {
        '': {
          templateUrl: '/workflow/pages/marketing-calendar/marketing-calendar.html?$$REVISION$$',
          controller: MarketingCalendarController
        }
      }
    })
}

export const workflowRoutes = routes
